import React from 'react'
import ChangePasswordForm from '../components/ChangePasswordForm/ChangePasswordForm'
import HomeTitle from '../components/HomeTitle/HomeTitle'
import AuthNavbar from '../components/AuthNavbar/AuthNavbar'
import { useSelector } from 'react-redux';
function ChangePassword() {
  const { currentLocal } = useSelector((state) => state.currentLocal);
  return (
    <div className="dashboard_content ">
      <AuthNavbar />
      <HomeTitle title={currentLocal.home.changePassword} />
      <ChangePasswordForm />
    </div>
  )
}

export default ChangePassword
